module.exports = __webpack_public_path__ + "static/img/zb2.e8abea2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/img/zb2.gif
// module id = /EGe
// module chunks = 1